import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

const timezoneMap = {
  hk: 8,
  tw: 8,
  en: 8,
  sg: 8,
  my: 8,
  ph: 8,
  id: 7,
  th: 7,
  vi: 7
}

/**
 * 根据地区时区格式化时间
 * @param {number|string} ts 时间戳或日期字符串
 * @param {string} locale 地区代码
 * @param {string} format 格式化模板
 * @returns {string}
 */
export const formatInTimezone = (ts, locale, format = 'MM/DD HH:mm') => {
  if (!ts) return '—'
  const offset = timezoneMap[locale] || 8
  // 使用 dayjs.utc(ts) 将输入视为 UTC 时间，然后通过 utcOffset 设置目标时区偏移
  return dayjs.utc(ts).utcOffset(offset).format(format)
}

/**
 * 格式化日期标签 (YYYYMMDD)
 * @param {string} dateStr 
 * @param {string} locale 
 * @returns {string}
 */
export const formatDateTabInTimezone = (dateStr) => {
  if (!dateStr) return ''
  // 日期标签通常是固定的 YYYYMMDD，这里保持原样格式化即可，或者也可以考虑时区
  // 但由于 dateStr 不含具体时间，通常不需要时区转换
  return dayjs(dateStr, "YYYYMMDD").format("MM/DD")
}
